import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import styles from './CardShoppingHistory.module.css';


function setColorLabelStatus(status){
    if(status === "Completada"){
        return "rgba(11, 114, 42, 0.81)";
    }else if(status === "En proceso"){
        return "rgba(31, 29, 145, 0.87)";
    }else{
        return "rgb(168, 21, 65)"; 
    }
}

function getDisplayStatus(status){
    if(status === "Completada"){
        return "Entrega completada";
    }else if(status === "En proceso"){
        return "Preparando en asociación";
    }else{
        return "Listo para retiro";
    }
}

function getDialogMessage(status){
    if(status === "Completada"){
        return "¡Gracias por preferirnos! Su pedido ha sido entregado exitosamente. Esperamos que disfrute sus productos y nos siga eligiendo para sus futuras compras.";
    }else if(status === "En proceso"){
        return "Su pedido se está preparando en la asociación seleccionada. Estará listo para ser retirado en un máximo de 3 días. Le notificaremos cuando esté disponible.";
    }else{
        return "¡Su pedido está listo! Puede venir a recogerlo en la asociación seleccionada lo más pronto posible. Recuerde traer un documento de identificación.";
    }
}

const CardShoppingCart = (props) =>{

    const [openDescriptionModal, setOpenDescriptionModal] = React.useState(false);

    const purchase = props.purchaseData;

    const statusLabelColor = setColorLabelStatus(purchase.status);
    const displayStatus = getDisplayStatus(purchase.status);
    const dialogMessage = getDialogMessage(purchase.status);

    const handleDescriptionOpen = () =>{
        setOpenDescriptionModal(true);
    }

    const handleDescriptionClose = () =>{
        setOpenDescriptionModal(false);
    }

    return(
        <>
            <Box className={styles.cardContainerBox} onClick={handleDescriptionOpen}>
                <div style={{flexFlow:'column', width: '100%'}}>
                    <div className={styles.statusLabel} style={{backgroundColor:statusLabelColor}}>
                        {displayStatus}
                    </div>
                    <div style={{padding:'10px'}}>
                        <div className={styles.dateLabel}>
                            <div className={styles.labelTitle}>
                                Fecha:
                            </div>
                            <div >
                                {purchase.date}
                            </div>
                        </div>
                        <div className={styles.warehouseLabel}>
                            <div className={styles.labelTitle}>
                                Punto de venta:
                            </div>
                            <div>
                                {purchase.warehouse}
                            </div>
                        </div>
                    </div>
                    <div style={{flexFlow: 'row'}}>
                        <div className={styles.priceLabel}>
                            <div className={styles.labelTitle}>
                                Precio total:
                            </div>
                            <div>
                                ₡{purchase.price}
                            </div>
                        </div>
                        <div className={styles.warehouseLabel} style={{marginTop:"15px", marginRight:'10px'}}>
                            <div className={styles.labelTitle}>
                                Código:
                            </div>
                            <div>
                                {purchase.code}
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
            <Dialog
                open={openDescriptionModal}
                onClose={handleDescriptionClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
               
            >
                <DialogTitle id="alert-dialog-title">
                    {"Detalle de compra"}
                </DialogTitle>
                <DialogContent  style={{padding:'40px'}}>
                    <DialogContentText id="alert-dialog-description">
                        {dialogMessage}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </>
    );

};

export default CardShoppingCart;